import React from 'react';
import { useTranslation } from 'react-i18next';

const PublicDisruption = ({ report, beta }) => {
  const { t } = useTranslation();

  if (!report.public_disruption_type) {
    return null;
  }

  return (
    <div className="further-details">
      {beta && <div className="border-b my-4 border-[#F4F5F7]" />}
      <h2>Further Details</h2>
      <table>
        <tbody>
          {report.public_disruption_type && (
            <tr>
              <th>Type</th>
              <td>{t(`public_disruption.${report.public_disruption_type.toLowerCase()}`)}</td>
            </tr>
          )}
          {report.protest_size && (
            <tr>
              <th>Size</th>
              <td>{t(`public_disruption.${report.protest_size.toLowerCase()}`)}</td>
            </tr>
          )}
          {report.protest_type && (
            <tr>
              <th>Violent</th>
              <td>{t(`public_disruption.${report.protest_type.toLowerCase()}`)}</td>
            </tr>
          )}
          {report.protest_armed && (
            <tr>
              <th>Armed</th>
              <td>{t(`public_disruption.${report.protest_armed.toLowerCase()}`)}</td>
            </tr>
          )}
          {report.perimeter_breach_size > 0 && (
            <tr>
              <th>Breach Size</th>
              <td>{report.perimeter_breach_size}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PublicDisruption;
